import { useEffect } from 'react'

/**
 * OAuth callback page for Meta (Facebook/Instagram).
 * This page is opened in a popup by the ChannelsPage.
 * It extracts the OAuth code from the URL and posts it back to the opener window.
 */
export function MetaOAuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const error = params.get('error')

    if (code && window.opener) {
      window.opener.postMessage({ type: 'META_OAUTH_CALLBACK', code }, window.location.origin)
    } else if (error) {
      window.opener?.postMessage({ type: 'META_OAUTH_ERROR', error }, window.location.origin)
      window.close()
    } else {
      window.close()
    }
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-600">Completing authorization...</p>
        <p className="text-sm text-gray-400 mt-1">This window will close automatically.</p>
      </div>
    </div>
  )
}

export default MetaOAuthCallback
